import DOMPurify from 'dompurify';
import { useCallback } from 'react';
import { useMedia } from 'src/store/media/useMedia';
import { MediaData } from 'src/types/helios/Media';
import { replaceMediaIdsWithPresignedUrlsAnyContent } from 'src/utils/mediaUtils';

interface SafeHtmlProps {
  html: string;
  mediaResponse?: MediaData[];
}

const SafeHtml: React.FC<SafeHtmlProps> = ({ html, mediaResponse }) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  const { mediaList } = useMedia();
  const newMediaList = [...(mediaList || []), ...(mediaResponse || [])];
  const finalContent = useCallback(
    () => replaceMediaIdsWithPresignedUrlsAnyContent(sanitizedHtml, newMediaList),
    [newMediaList, sanitizedHtml],
  );

  return (
    <div>
      <base target="_blank"></base>
      <div
        className="safe-html-content"
        style={{ overflowX: 'auto' }}
        dangerouslySetInnerHTML={{
          __html: finalContent(),
        }}
      />
    </div>
  );
};

export default SafeHtml;
